import { z } from "zod";
export const AccessibilityStandardRegistryV1Schema = z
    .object({
    schemaVersion: z.literal("accessibility-standard-registry.v1.0"),
    localTargetedProofComplete: z.literal(true),
    hostedOrExternalProofClaimed: z.literal(false),
    recordedAt: z.string().datetime(),
})
    .strict();
export function recordLocalAccessibilityStandardRegistry(recordedAt) {
    return AccessibilityStandardRegistryV1Schema.parse({
        schemaVersion: "accessibility-standard-registry.v1.0",
        localTargetedProofComplete: true,
        hostedOrExternalProofClaimed: false,
        recordedAt,
    });
}
//# sourceMappingURL=accessibility-standard-registry.js.map